import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiesPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="cookies-policy-page" className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-500 mb-8 transition-colors" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Advertising and Cookies Policy</h1>
        <p className="text-sm text-slate-400 mb-12">Last updated: February 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-sm leading-relaxed text-slate-600">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">1. What Are Cookies?</h2>
            <p>Cookies are small text files placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences, analyzing site usage, and assisting in our marketing efforts.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">2. Types of Cookies We Use</h2>
            <ul className="list-disc pl-6 space-y-3 mt-3">
              <li><strong>Essential Cookies:</strong> Required for the website to function properly. These cannot be disabled.</li>
              <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
              <li><strong>Functional Cookies:</strong> Enable enhanced functionality and personalization, such as remembering your training preferences.</li>
              <li><strong>Advertising Cookies:</strong> Used to deliver relevant advertisements and track the effectiveness of our marketing campaigns.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">3. Advertising</h2>
            <p>We may use third-party advertising partners to display ads on other websites based on your visits to our platform. These partners may use cookies and similar technologies to collect information about your browsing activities to provide you with targeted advertising.</p>
            <p className="mt-3">Our advertising partners may include:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Google Ads</li>
              <li>LinkedIn Advertising</li>
              <li>Meta (Facebook/Instagram) Advertising</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">4. Managing Cookies</h2>
            <p>You can control and manage cookies in your browser settings. Please note that removing or blocking cookies may impact your user experience and some features may no longer be available.</p>
            <p className="mt-3">Most browsers allow you to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>See what cookies you have and delete them individually</li>
              <li>Block third-party cookies</li>
              <li>Block cookies from particular sites</li>
              <li>Block all cookies</li>
              <li>Delete all cookies when you close your browser</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">5. Updates to This Policy</h2>
            <p>We may update this Advertising and Cookies Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">6. Contact Us</h2>
            <p>If you have questions about our use of cookies or advertising practices, please contact us at:</p>
            <p className="mt-2">
              SkillsimAI<br />
              1 Canada Square, Canary Wharf<br />
              London E14 5AB, UK<br />
              Email: info@skillsimai.com<br />
              Phone: +44 20 3059 3450
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
